import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { downloadCSV,stopProcessCSV,statusCSV,generateCSV } from '../../../../../jsx/reducers/paygAdmin/extract'
import { isEmpty } from 'lodash'
import Dialog  from '../../commonModules/interface/Dialog';

import Select from 'react-select';
import { Button, Grid ,TextField, Box,Paper,Link ,CircularProgress, LinearProgress,Typography, Card, CardHeader, CardContent} from '@material-ui/core';
import { StoreRounded, AccountCircleRounded, MonetizationOnRounded } from '@material-ui/icons';
import { DatePicker,LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import DatePickerCustom from '../../commonModules/interface/DatePickerCustom';
import { blue, green, pink, teal } from '@material-ui/core/colors';
import { InputSelectMagasin } from '../../commonModules/interface/form-input-inline';
import { toast } from 'react-toastify';

var Moment = require('moment');


class ExtractList extends Component {
    state = { 
        data: "",
        url:"inventory/sales",
        list:[],
        loading: false,
        loadingExtractCustoms: false,
        downloadProcess: false,
        downloadProcessInventory: false,
        dateFormDomainModel: false,
        extractPaiment: false,
        extractPaimentDetailed: false,
        timeStart: new Date(),
        timeStop: new Date(),
        typeInfo: "",
        dataset: "",
        datasetP: "",
        processID: "",
        fields: [],
        progress: 0,
        itemDownloaded: 0,
        totalItemToDownload: 0,
        linkAvailable :false,
        fieldList:[
            {value: "", label: ""},
        ],
        start_date: new Date(),
        end_date: new Date(),

     }
    // componentDidMount = () => {
    //     this.fetchCustomField()
    // }
    fetchClients = () => {
        //Get Data From paygo User
        var methodName = 'fetchClients csv';
        const { CLIENTS ,SUBSCRIPTIONS} = this.props
        
        var dataset = "Status, Box Id, Nom client, derniere connexion, dernier paiement, prochain arret, montant paye, montant restant a payer,dernier code,alarme, evaluation , Nom abonnement\n";
        try {
            !isEmpty(CLIENTS) &&  Object.keys(CLIENTS).map( ID => {
            const client = CLIENTS[ID].resume;
            var subName = "";
            console.log(CLIENTS[ID])
            if (typeof client !== "undefined" ){
                console.log(client.subscriptionID)
                if (typeof SUBSCRIPTIONS[client.subscriptionID] !== "undefined"){
                    subName = SUBSCRIPTIONS[client.subscriptionID].name
                }

                var dataV = client.systemStatus+ 
                ','+client.idBox+
                ','+client.clientName+
                ','+client.lastConnexion+
                ','+client.lastPayment+
                ','+client.nextStop+
                ','+client.totalPayed+
                ','+client.totalToPay+
                ','+client.lastCode+
                ','+client.errorCode+
                ','+client.paymentDelay+
                ','+subName+'\n';
                dataset += dataV;
            }
    
          })        
        } catch (e) {
            console.log('[ERROR], ', methodName, ',Parsing data from serveur ', e);
            return;
        }

        this.startDownload(dataset, "MyJouleBox-User-Data.csv")
    }
    fetchPayments = () => {
        var methodName = 'fetch payments';

        const { PAYMENTS } = this.props
        var dataset = "Transaction Id,Date Paiement,Montant,Box,Methode Paiement,Nb jour, Code\n";
        try {
            !isEmpty(PAYMENTS) && Object.values(PAYMENTS).forEach( payment => {        
                var dataV = payment.transactionId.substring(0, 9) + 
                ',' + Moment(Date.parse(payment.timePayment)).format('YYYY-MM-DD HH:mm ') +
                ',' + payment.money + 
                ',' + payment.boxId + 
                ',' + payment.methodPayment + 
                ',' + payment.day + 
                ',' + payment.codeId + 
                '\n';

                dataset += dataV;
                // console.log('[INFO]', dataV);
            })
    
        } catch (e) {
            console.log('[ERROR], ', methodName, ',Parsing data from serveur ', e);
            return;
        }
    
        this.startDownload(dataset, "MyJouleBox-Payment-Data.csv")
        
    }

    stopInventoryProcess = () => {
        this.setState({
            downloadProcessInventory: false,
            linkAvailable:false,
            itemDownloaded: 0,
            totalItemToDownload: 0
        })
        this.props.stopProcessCSV(this.state.processID)
    }
    handleDownloadInventory = () => {
        const processID = this.state.processID
        const type = this.state.typeInfo
        this.props.downloadCSV(processID,type)
        this.setState({
            downloadProcessInventory: false,
            linkAvailable:false,
            itemDownloaded: 0,
            totalItemToDownload: 0,
            dateForm : false,
            currentExt: "",
        })
    }
    openDateFormDomainModel = (extract) => {
        if (extract === "value-stock"){
           
        } else {
            this.setState({
                dateFormDomainModel : true,
                currentExt: extract,
                typeInfo: extract,
            })
        }
    }
    openDateForm = (extract) => {
        let fromStart = ["inventory", "inventory-history", "commercials", "commercials-history"]
        if (fromStart.includes(extract) ){
            this.setState({
                dateForm : true,
                currentExt: extract,
                typeInfo: extract,
                start_date: new Date('January 01, 2000 23:15:30'),
            })
        } else {
            this.setState({
                dateForm : true,
                currentExt: extract,
                typeInfo: extract,
            })
        }
    }
    handleSubmitDateForm = () => {
        const { start_date, end_date, currentExt} = this.state;
        if (start_date && end_date && start_date < end_date) {
            let data = {
                start_date: this.state.start_date,
                end_date: this.state.end_date,
            }
            this.fetchDataStoreHouse(currentExt, data)
        } else {
            console.log("invalid dates");
            // this.notif('danger', "invalid dates")
        }
    }

    fetchStatus = (processID) => {
        this.props.statusCSV(processID).then( dataset => {
            console.log({dataset});
            console.log("[INFO] fetchStatus ", dataset);
            const normalise = 100*(dataset.actual / (dataset.total));
            console.log("[INFO] fetchStatus ", dataset.actual," /",dataset.total, " => ",normalise);

            this.setState({progress: normalise, itemDownloaded: dataset.actual, totalItemToDownload: dataset.total})

            if (dataset.status == "COMPLETED") {
                this.setState({linkAvailable: true, progress: 100, itemDownloaded: dataset.total })
                // this.state.downloadProcessInventory ? 
                // this.handleDownloadInventory() :
                // this.handleDownload()
            } else {
                setTimeout(() => {
                    this.fetchStatus(processID)
                    }, 3000);
            }
        }).catch( err => {
            console.log("[ERROR], fetchStatus, ",err)
        })
    }

    fetchDataStoreHouse = (info, dates) => {
        this.setState({downloadProcessInventory: true, typeInfo:info})
        this.props.generateCSV(info, dates).then(
            (processID) => {
                console.log("[INFO], fetchDataStoreHouse, ",processID)
                this.setState({processID :  processID })
                this.fetchStatus(processID)
            }
        ).catch(
            (err) => {
                console.log("[ERROR], fetchDataStoreHouse, ",err)
            }
        )
    }
     
    startDownload = (href, title) => {
        const link = document.createElement('a');
        link.href = "data:application/csv;charset=utf-8," + encodeURIComponent(href);
        link.setAttribute('download', title);

        // 3. Append to html page
        document.body.appendChild(link);
        // 4. Force download
        link.click();
        // 5. Clean up and remove the link
        link.parentNode.removeChild(link);
    }

    // fetchCustomField = async () => {
    //     try {
    //         let req = await fetch('/extract/custom/fields',{
    //             method:'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
    //             },
    //             credentials: 'same-origin',
       
    //         })
    //         const res = await req.json()
    //         console.log({res});
            
    //         let fieldList = []
    //         if(res.error === "OK"){
    //             res.list.forEach( field => {
    //                 fieldList.push({label: field, value: field})
    //             })
    //             console.log('====================================');
    //             console.log("fieldList", {fieldList});
    //             console.log('====================================');

    //             this.setState({fieldList})

    //         } 
    //         // else {
    //         //     this.props.notif( "danger", res.content, "Erreur")
    //         //     console.log("[ERROR] fetchCustomField ", res.error);
    //         // }
    //     } catch (error) {
    //         console.log('====================================');
    //         console.log("[ERROR] fetchCustomField ", error);
    //         console.log('====================================');
    //         // this.props.notif( "danger", error, "Erreur")
    //     }
    // }
    handleChange = (fields) => {
        this.setState({ fields });
        console.log(`Option selected:`, fields);
    }
    handleDownload = async () => {
        console.log('====================================');
        console.log("handleDownload");
        console.log('====================================');
        try {
            let req = await fetch('/extract/download/custom/csv',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify({id:this.state.processID}),
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(res.error === "OK"){
                var today = new Date();
                let month = today.getMonth() + 1;
                let monthVal = month
                if (month < 10){
                    monthVal = `0${month}`
                }
                let date = today.getDate()
                const fileNameExtractFile = "MyJouleBox-customcsv_"+today.getFullYear()+"/"+monthVal+"/"+date+".csv"
                this.startDownload(res.dataset, fileNameExtractFile)
            } else {
                // this.props.notif( "danger", res.content, "Erreur")
                console.log("[ERROR] handleSubmitCustom ", res.error);
            }
        } catch (error) {
            // this.props.notif( "danger", error, "Erreur")
            console.log('====================================');
            console.log("[ERROR] handleSubmitCustom ", error);
            console.log('====================================');
        }
        this.setState({linkAvailable: false})
    }

    stopProcess = async () => {
        this.setState({downloadProcess: false})
        try {
            let req = await fetch('/extract/status/stopprocess',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify({id:this.state.processID}),
                credentials: 'same-origin',
        
            })
            const res = await req.json()
            console.log({res});
        }catch (error) {
            // this.props.notif( "danger", error, "Erreur")
            console.log('====================================');
            console.log("[ERROR] stopProcess ", error);
            console.log('====================================');
        }
    }
    handleCheckDownload = async (processID ) =>{
        if (this.state.processID === ""){
            return
        }

        try {
            let req = await fetch('/extract/status/custom/csv',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify({id:processID}),
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            if(res.error === "OK"){
                console.log("[INFO] handleCheckDownload ", res.dataset);
                const normalise = 100*(res.dataset.actual / (res.dataset.total));
                console.log("[INFO] handleCheckDownload ", res.dataset.actual," /",res.dataset.total, " => ",normalise);

                this.setState({progress: normalise, itemDownloaded: res.dataset.actual, totalItemToDownload: res.dataset.total})
   
                if (res.dataset.status == "COMPLETED") {
                    this.setState({linkAvailable: true, progress: 100, itemDownloaded: 100 })
                } else {
                    setTimeout(() => this.handleCheckDownload(processID), 3000);
                }
            } else {
                // this.props.notif( "danger", res.content, "Erreur")
                console.log("[ERROR] handleCheckDownload ", res.error);
            }
        } catch (error) {
            // this.props.notif( "danger", error, "Erreur")
            console.log('====================================');
            console.log("[ERROR] handleCheckDownload ", error);
            console.log('====================================');
        }
    }
    fetchData = async (datatype)  => {
        let body = ""
        if (datatype === "prospectAll" || datatype === "angaza"){
            this.setState({downloadProcess: true})
            body = JSON.stringify({type:  datatype})
        }
        if (datatype === "customs"){
            this.setState({ loadingExtractCustoms: true })
            let data = this.state.fields.map(field => field.value)
            body = JSON.stringify({type:"customs", info:data})
        }
        if (datatype === "paymentlist"){
            this.setState({ loadingExtractCustoms: true })
            let data = {timeStart: this.state.timeStart,timeStop: this.state.timeStop}
            body = JSON.stringify({type:"paymentlist", timeinfo:data})
        }
        if (datatype === "paymentdetailledlist"){
            this.setState({ loadingExtractCustoms: true })
            let data = {timeStart: this.state.timeStart,timeStop: this.state.timeStop}
            body = JSON.stringify({type:"paymentdetailledlist", timeinfo:data})
        }
        if (datatype === "revenues"){
            this.setState({ loadingExtractCustoms: true })
            let data = {timeStart: this.state.timeStart,timeStop: this.state.timeStop}
            body = JSON.stringify({type:"revenues", timeinfo:data})
        }
        if (datatype === "control_stock"){
            this.setState({ loadingExtractCustoms: true })
            let data = {timeStart: this.state.timeStart,timeStop: this.state.timeStop}
            body = JSON.stringify({type:"control_stock", timeinfo:data})
        }

        console.log('====================================');
        console.log("handleSubmitCustom", {body});
        console.log('====================================');
        try {
            let req = await fetch('/extract/generate/custom/csv',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: body,
                credentials: 'same-origin',
            })
            
            const res = await req.json()
            console.log({res});
            if(res.error === "OK"){
                console.log("[INFO] handleSubmitCustom ", res.processID);
                this.setState({processID: res.processID })
                this.handleCheckDownload(res.processID)
            } else {
                // this.props.notif( "danger", res.content, "Erreur")
                console.log("[ERROR] handleSubmitCustom ", res.error);
            }
        } catch (error) {
            console.log('====================================');
            console.log("[ERROR] handleSubmitCustom ", error);
            console.log('====================================');
        }
    }
    upload = (file) => {
        console.log({file});
        fetch('/extract/inventory/stocks/import', { // Your POST endpoint
          method: 'POST',
          body: file[0]
        }).then(
          response => response.json() // if the response is a JSON object
        ).then(
          success => console.log(success) // Handle the success response object
        ).catch(
          error => console.log(error) // Handle the error response object
        );
      };

    render() {
        console.log('====================================');
        console.log("[STATE]", this.state);
        console.log('====================================');
        const { loading } = this.props;
        return (
            <Grid container spacing={2}>
                {/* <div>Extract list</div> */}
                <Grid item md={4} sm={6} xs={12}>
                    <Card className="text-center">
                        <CardHeader
                            title="Magasin"
                            avatar={
                                <StoreRounded />
                            }
                        />
                        <CardContent>
                            {/* <h4><StoreRounded /> Magasin</h4> */}
                            <Box p={1}>
                                <Button 
                                    // color="secondary"
                                    style={{ backgroundColor : teal[100]}}
                                    variant="contained" 
                                    onClick={() => this.openDateForm("inventory-history")} 
                                    // onClick={() => this.fetchDataStoreHouse("inventory")} 
                                    disabled={loading}
                                >
                                    Historique Stock
                                </Button>

                            </Box>
                        
                            <Box p={1}>
                                <Button 
                                    // color="secondary"
                                    style={{ backgroundColor : teal[100]}}
                                    variant="contained" 
                                    onClick={() => this.openDateForm("inventory")} 
                                    disabled={loading}
                                >
                                    Inventaire Stock
                                </Button>
                            </Box>
                        
                            <Box p={1}>
                                <Button 
                                    // color="secondary"
                                    style={{ backgroundColor : teal[100]}}
                                    variant="contained" 
                                    onClick={() => this.openDateForm("value-stock")} 
                                    // onClick={() => this.fetchDataStoreHouse("value-stock")} 
                                    disabled={loading}
                                >
                                    Valeur Stock
                                </Button>
                            </Box>
                        
                            <Box p={1}>
                                <Button 
                                    color="primary"
                                    variant="contained" 
                                    onClick={() => this.openDateForm("commercials-history")} 
                                    disabled={loading}
                                >
                                    Historique Commercial
                                </Button>

                            </Box>
                            <Box p={1}>
                                <Button 
                                    color="primary"
                                    variant="contained" 
                                    onClick={() => this.openDateForm("commercials")} 
                                    disabled={loading}
                                >
                                    Inventaire Commercial
                                </Button>

                            </Box>

                            <Box p={1}>
                                <Button 
                                    // color="secondary"
                                    style={{ backgroundColor : blue[100]}}
                                    variant="contained" 
                                    // onClick={() => this.fetchDataStoreHouse("sales")} 
                                    onClick={() => this.openDateForm("sales-op")}
                                    disabled={loading}
                                >
                                    Historique Ventes
                                </Button>

                            </Box>
                            <Box p={1}>
                                <Button 
                                    // color="secondary"
                                    style={{ backgroundColor : blue[100]}}
                                    variant="contained" 
                                    // onClick={() => this.fetchDataStoreHouse("sales")} 
                                    onClick={() => this.openDateForm("direct-sales")}
                                    disabled={loading}
                                >
                                    Historique Ventes Directes
                                </Button>

                            </Box>
                            
                            {/* <Box p={1}>
                                <Button 
                                    // color="secondary"
                                    style={{ backgroundColor : blue[100]}}
                                    variant="contained" 
                                    onClick={() => this.openDateForm("best-sellers")} 
                                    // onClick={() => this.fetchDataStoreHouse("best-sellers")} 
                                    disabled={loading}
                                >
                                    Meilleures ventes
                                </Button>
                            </Box> */}
                            <Box p={1}>
                                <Button 
                                    // color={green[200]}
                                    style={{ backgroundColor : green[100]}}
                                    variant="contained" 
                                    onClick={() => this.fetchDataStoreHouse("priceList")} 
                                    disabled={loading}
                                >
                                    Liste des Produits
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button 
                                    style={{ backgroundColor : green[100]}}
                                    variant="contained" 
                                    onClick={() => this.fetchDataStoreHouse("price-details")} 
                                    disabled={loading}
                                >
                                    Prix Produits
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button 
                                    style={{ backgroundColor : pink[100]}}
                                    variant="contained" 
                                    onClick={() => this.openDateForm("COGS")} 
                                    disabled={loading}
                                >
                                    COGS et Revenus
                                </Button>
                            </Box>
                            {/* <Box p={1}>
                                <Button 
                                    style={{ backgroundColor : pink[100]}}
                                    variant="contained" 
                                    onClick={() => this.openDateForm("link-purchase")} 
                                    disabled={loading}
                                >
                                    Achat Match
                                </Button>
                            </Box> */}
                            {/* <Box p={1}>
                                <Button 
                                    // color={green[200]}
                                    style={{ backgroundColor : green[100]}}
                                    variant="contained" 
                                    onClick={() => this.fetchDataStoreHouse("temp-factures")} 
                                    disabled={loading}
                                >
                                    Template Factures
                                </Button>
                            </Box> */}
                            {/* <Box p={1}>
                                <Button 
                                    // color="primary"
                                    style={{ backgroundColor: "lightPink" }}
                                    variant="contained" 
                                    onClick={() => this.fetchDataStoreHouse("reappro-err")} 
                                    disabled={loading}
                                >
                                    Stock Errors
                                </Button>
                            </Box> */}
                            {/* <Box p={1}>
                                <div className="form-group">
                                    <div className="col-lg-10">
                                        <div className="alert alert-info">
                                            <input type="file" name="file" style={{visibility: "hidden"}} id="pdffile" 
                                                onChange={ (e) => this.setState({ file: e.target.files})}
                                            />
                                            <label htmlFor="pdffile">Choose A File</label>
                                            <Button className="btn btn-primary" onClick={this.upload}>Upload</Button>
                                        </div>
                                    </div>
                                </div>
                            </Box> */}
                        </CardContent>

                    </Card>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                    <Card className="text-center">
                        <CardHeader
                            title="Clients"
                            avatar={
                                <AccountCircleRounded />
                            }
                        />
                        <CardContent>
                        {/* <h4><AccountCircleRounded /> Clients</h4> */}
                            <Box p={1}>
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={() => this.fetchClients()} 
                                    disabled={loading}
                                >
                                    Infos Clients
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={() => this.fetchData("prospectAll")} 
                                    disabled={loading}
                                >
                                    Infos Prospects
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={() => this.setState({ custom: true })} 
                                    disabled={loading}
                                >
                                    Liste Client Personnalisé
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={() => this.fetchData("angaza")} 
                                    disabled={loading}
                                >
                                    Infos Angaza format
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={() => this.openDateFormDomainModel("revenues")} 
                                    disabled={loading}
                                >
                                    Revenues
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={() => this.openDateFormDomainModel("control_stock")} 
                                    disabled={loading}
                                >
                                    Control Stock
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item md={4} sm={6} xs={12}>
                    <Card className="text-center">
                        <CardHeader
                            title="Paiements"
                            avatar={
                                <MonetizationOnRounded />
                            }
                        />
                        <CardContent>
                            {/* <h4><MonetizationOnRounded/> Paiements</h4> */}
                            <Box p={1}>
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    //onClick={() => this.fetchPayments()}  
                                    onClick={() => this.setState({ dateFormDomainModel: true })} 
                                    disabled={loading}
                                >
                                    Liste Paiements
                                </Button>
                            </Box>
                            <Box p={1}>
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={() => this.setState({ extractPaimentDetailed: true })} 
                                    disabled={loading}
                                >
                                    Liste Paiements détaillé
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
                
                
                {/* {this.props.loading && 
                    <p>Téléchargement en cours</p>
                } */}
                {this.state.downloadProcessInventory &&
                    <Dialog
                        title="Extract Magasin Info"
                        block={true}
                        close={()=> this.stopInventoryProcess()}
                        // disabledSubmit={false}
                    >
                        <Box p={2}>

                            <Typography variant="caption" component="div" color="textSecondary">
                                Avancement {
                                    `${Math.round(this.state.progress)}%`
                                } ou {this.state.itemDownloaded} / {this.state.totalItemToDownload} 
                            </Typography>
                            {/* <CircularProgress variant="determinate" value={this.state.progress} />  */}
                            <LinearProgress variant="determinate" color="secondary" value={this.state.progress} />
                            { this.state.linkAvailable &&
                                <Box p={1}>
                                    <Button color="primary" onClick={this.handleDownloadInventory}>
                                        Download here
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Dialog>
                }
                {this.state.downloadProcess &&
                    <Dialog
                        title="Extract Process list"
                        block={this.state.downloadProcess}
                        close={()=> this.stopProcess()}
                    >
                        <Box p={2}>
                            <Typography variant="caption" component="div" color="textSecondary">Avancement {`${Math.round(
                            this.state.progress,
                            )}%`} ou {this.state.itemDownloaded} / {this.state.totalItemToDownload} </Typography>
                            {/* <CircularProgress variant="determinate" value={this.state.progress} />                               */}
                            <LinearProgress variant="determinate" color="secondary" value={this.state.progress} />
                            { this.state.linkAvailable &&
                                <Box p={1}>
                                    <Button color="primary" onClick={this.handleDownload}>
                                        Download here
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Dialog>
                }
                {this.state.custom &&
                    <Dialog
                        title="Extract Customs list"
                        block={true}
                        close={()=> { this.stopProcess(); this.setState({custom: false,loadingExtractCustoms:false})}}
                        submitAction={() => this.fetchData("customs") }
                        disabledSubmit={this.state.loadingExtractCustoms}
                    >
                        <Box p={2} style={{ minHeight: '300px'}}>
                            <InputSelectMagasin
                                label="Champs à Extraire"
                                value={this.state.fields}
                                onChange={this.handleChange}
                                options={this.state.fieldList.map( field => ({
                                    value: field.value,
                                    label: field.label,
                                    disabled:!!this.state.fields.find(element => element.value === field.value)
                                }))}
                                isMulti
                                // closeMenuOnSelect={false}
                                // closeOnSelect={false}
                                // components={makeAnimated()}
                                
                            />
                            
                            {/* <Button 
                                className="btn btn-success" 
                                onClick={this.handleSubmitCustom}
                                disabled={loading} >Valider</Button> */}

                            <Typography variant="caption" component="div" color="textSecondary">
                                Avancement {
                                    `${Math.round(this.state.progress)}%`
                                } ou {this.state.itemDownloaded} / {this.state.totalItemToDownload}
                            </Typography>
                            {/* <CircularProgress variant="determinate" value={this.state.progress} /> */}
                            <LinearProgress variant="determinate" color="secondary" value={this.state.progress} />
                            { this.state.linkAvailable &&
                                <Box p={1}>
                                    <Button color="primary" onClick={this.handleDownload}>
                                        Download here
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Dialog>
                }
                {this.state.dateFormDomainModel &&
                    <Dialog
                        title="Extract Paiment list"
                        block={this.state.dateFormDomainModel}
                        close={()=> { this.stopProcess();this.setState({dateFormDomainModel: false,loadingExtractCustoms:false})}}
                        submitAction={() => this.fetchData(this.state.typeInfo) }
                        disabledSubmit={this.state.loadingExtractCustoms}
                    >
                        <Box p={2}>
                
                            <Grid container spacing={2} >
                                <Grid item xs={12} sm={6} >
                                    <DatePickerCustom
                                        required
                                        label="Du"
                                        handleChange={(date)=> this.setState({ timeStart: date})}
                                        value={this.state.timeStart}
                                        id="timeStart"
                                        maxDate={this.state.timeStop || new Date()}

                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <DatePickerCustom
                                        required
                                        label="Au"
                                        handleChange={(date)=> this.setState({ timeStop: date})}
                                        value={this.state.timeStop}
                                        id="timeStop"
                                        maxDate={new Date()}
                                        minDate={this.state.timeStart || new Date()}
                                    />
                                </Grid>
                            </Grid>
                            {/* <Button 
                                className="btn btn-success" 
                                onClick={this.handleSubmitCustom}
                                disabled={loading} >Valider</Button> */}
                            <Typography variant="caption" component="div" color="textSecondary">
                                Avancement {
                                    `${Math.round(this.state.progress)}%`
                                } ou {this.state.itemDownloaded} / {this.state.totalItemToDownload}
                            </Typography>
                            {/* <CircularProgress variant="determinate" value={this.state.progress} /> */}
                            <LinearProgress variant="determinate" color="secondary" value={this.state.progress} />
                            { this.state.linkAvailable &&
                                <Box p={1}>
                                    <Button color="primary" onClick={this.handleDownload}>
                                        Download here
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Dialog>
                }
                {this.state.extractPaimentDetailed &&
                <Dialog
                title="Extract Paiment Détaillé list"
                block={this.state.extractPaimentDetailed}
                close={()=> { this.stopProcess();this.setState({extractPaimentDetailed: false,loadingExtractCustoms:false})}}
                submitAction={() => this.fetchData("paymentdetailledlist") }
                disabledSubmit={this.state.loadingExtractCustoms}
            >
                <Box p={2}>
                    {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker value={this.state.timeStart} onChange={date => this.setState({timeStart:date})}/>
                    <DatePicker value={this.state.timeStop} onChange={date => this.setState({timeStop:date})}/>
                    </MuiPickersUtilsProvider> */}
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box display="flex" flexDirection="column" gap={2}>
          <DatePicker
            label="Start Date"
            value={this.state.timeStart}
            onChange={(date) => this.setState({ timeStart: date })}
          />
          <DatePicker
            label="Stop Date"
            value={this.state.timeStop}
            onChange={(date) => this.setState({ timeStop: date })}
          />
        </Box>
      </LocalizationProvider>
        
                    
                    {/* <Button 
                        className="btn btn-success" 
                        onClick={this.handleSubmitCustom}
                        disabled={loading} >Valider</Button> */}
                    <Typography variant="caption" component="div" color="textSecondary">
                        Avancement {
                            `${Math.round(this.state.progress)}%`
                        } ou {this.state.itemDownloaded} / {this.state.totalItemToDownload}
                    </Typography>
                    {/* <CircularProgress variant="determinate" value={this.state.progress} /> */}
                    <LinearProgress variant="determinate" color="secondary" value={this.state.progress} />
                    { this.state.linkAvailable &&
                        <Box p={1}>
                            <Button color="primary" onClick={this.handleDownload}>
                                Download here
                            </Button>
                        </Box>
                    }
                </Box>
            </Dialog>
                }
                {this.state.dateForm &&
                    <Dialog
                        submitAction={this.handleSubmitDateForm}
                        close={ () => this.setState({ dateForm: false, currentExt: "", titleDialog: "" }) }
                        submitTitle="Télécharger"
                        title="Periode"
                        block={true}
                    >
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={6} >
                                {this.state.currentExt !== "value-stock" &&
                                    <DatePickerCustom
                                        required
                                        label="Du"
                                        handleChange={(date)=> this.setState({ start_date: date})}
                                        value={this.state.start_date}
                                        id="start_date"
                                        maxDate={this.state.end_date || new Date()}
                                        
                                        />
                                    }
                                {this.state.currentExt === "value-stock" &&
                                    <DatePickerCustom
                                        disabled
                                        label="Du"
                                        // handleChange={(date)=> this.setState({ start_date: date})}
                                        value={this.state.start_date}
                                        id="start_date"
                                        // maxDate={this.state.end_date || new Date()}
                                    />
                                }
                            </Grid>
                            <Grid item xs={12} sm={6} >
                                {this.state.currentExt !== "value-stock" &&
                                    <DatePickerCustom
                                        required
                                        label="Au"
                                        handleChange={(date)=> this.setState({ end_date: date})}
                                        value={this.state.end_date}
                                        id="end_date"
                                        maxDate={new Date()}
                                        minDate={this.state.start_date || new Date()}
                                    />
                                }
                                {this.state.currentExt === "value-stock" &&
                                    <DatePickerCustom
                                        required
                                        label="Valeur Stock Au"
                                        handleChange={(date)=> this.setState({ end_date: date})}
                                        value={this.state.end_date}
                                        id="end_date"
                                        maxDate={new Date()}
                                        minDate={this.state.start_date || new Date()}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </Dialog>
                }
            </Grid>
        );
    }
}

function mapStateToProps(state){
    return {
        PROSPECTS: state.prospects.RESUME,
        CLIENTS: state.clients,
        SUBSCRIPTIONS: state.subscriptions,
        PAYMENTS: state.payments,
        INSTALLERS: state.installers,
        loading: state.extract.fetching
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        generateCSV,
        statusCSV,
        stopProcessCSV,
        downloadCSV
    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(ExtractList);